import { useState, useEffect } from "react";
import { WifiOff, Wifi } from "lucide-react";

export default function OfflineBanner() {
  const [isOffline, setIsOffline] = useState(!navigator.onLine);
  const [showReconnected, setShowReconnected] = useState(false);

  useEffect(() => {
    const goOffline = () => setIsOffline(true);
    const goOnline = () => {
      setIsOffline(false);
      setShowReconnected(true);
      setTimeout(() => setShowReconnected(false), 3000);
    };

    window.addEventListener("offline", goOffline);
    window.addEventListener("online", goOnline);
    return () => {
      window.removeEventListener("offline", goOffline);
      window.removeEventListener("online", goOnline);
    };
  }, []);

  if (!isOffline && !showReconnected) return null;

  return (
    <div
      data-testid="offline-banner"
      className={`fixed top-0 left-0 right-0 z-[9999] flex items-center justify-center gap-2 py-2 px-4 text-sm font-medium transition-all duration-300 ${
        isOffline
          ? "bg-red-600 text-white"
          : "bg-green-600 text-white"
      }`}
    >
      {isOffline ? (
        <>
          <WifiOff size={16} />
          <span>You're offline - some features may be limited</span>
        </>
      ) : (
        <>
          <Wifi size={16} />
          <span>Back online</span>
        </>
      )}
    </div>
  );
}
